import React, { useEffect, useState } from "react";
import { Form, Button, Alert, Card } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import logo from "../../assets/logo.svg";
import "./Auth.css";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import API from "../../constants/apiConfig";

function SignupPage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(API.SIGNUP, {
        method: "POST",
        headers: { "Content-Type": "application/json", arkv: "!$Learn#$!" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.code === "200") {
        setSuccess("Joining successful!");
        navigate("/login", { state: { email: formData.email } });
      } else {
        setError(result.message || "Something went wrong");
      }
    } catch (error) {
      setError("Unable to join, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      <Card className="auth-card">
        <Card.Body>
          <div className="text-center mb-4">
            <img src={logo} alt="Game Illustration" className="auth-logo" />
          </div>
          <h2 className="text-center auth-heading">Join the Adventure!</h2>
          <p className="text-center auth-subtext">
            Learn to manage money and play fun challenges.
          </p>
          <Form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="button"
              disabled={loading}
            >
              Join
            </Button>
          </Form>
          {success ? (
            <Alert variant="success">"{success}"</Alert>
          ) : error ? (
            <Alert variant="danger">{error}</Alert>
          ) : null}
          <div className="mt-4 text-center">
            <p>
              Already have an account?{" "}
              <Link to="/login" className="auth-login-link">
                Let's go
              </Link>
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default SignupPage;
